export default "__VITE_ASSET__BI5NRXA3__";